import { render } from "./SplashView.vue?vue&type=template&id=6936f9b7&scoped=true"
import script from "./SplashView.vue?vue&type=script&lang=js"
export * from "./SplashView.vue?vue&type=script&lang=js"

import "./SplashView.vue?vue&type=style&index=0&id=6936f9b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6936f9b7"]])

export default __exports__